import React, { useState } from 'react';
import { Button, Form, Input, Alert, notification } from "antd";
import { MailOutlined, LockOutlined } from '@ant-design/icons';
import { motion } from "framer-motion"
import { getBPMasterData, getItemMasterData , getAuthWhs} from '../../store/reducers/masterData/masterData'
import { postLogin} from '../../store/reducers/auth/auth'
import {  useDispatch } from 'react-redux'
import {getAccessRoles} from '../../store/reducers/permistion/index'

export const LoginForm = props => {
	const dispatch = useDispatch()
	const [alert, setAlert] = useState({
		showMessage: false,
		message: ''
	})
	const [loadingLogin, setloadingLogin] = useState(false)
	const initialCredential = {
		UserName: '',
		PassWord: ''
	}
	const onLogin = async (loginForm) => {
		try {
			setloadingLogin(true)
			await dispatch(postLogin(loginForm)).then
				((res) => {
					if (res.payload.success) {
				console.log(res)

						dispatch(getBPMasterData())
						dispatch(getItemMasterData())
						dispatch(getAccessRoles())
						dispatch(getAuthWhs(res.payload.user))
						setloadingLogin(false)
						return notification.success({
							message: res.payload.message || "Đăng nhập thành công",
						})
					} 
					else {
						setloadingLogin(false)
						return notification.error({
							message: "Đăng nhập thất bại",
						})
					}
				}
				)
		}
		catch (error) {
			console.log(error);
			setloadingLogin(false)
			return notification.error({
				message: "Đăng nhập thất bại",
			})
		}
	};

	return (
		<>
			<motion.div
				initial={{ opacity: 0, marginBottom: 0 }}
				animate={{
					opacity: alert.showMessage ? 1 : 0,
					marginBottom: alert.showMessage ? 20 : 0
				}}>
				<Alert type="error" showIcon message={alert.message}></Alert>
			</motion.div>
			<Form
				layout="vertical"
				name="login-form"
				initialValues={initialCredential}
				onFinish={onLogin}
			>
				<Form.Item
					name="UserName"
					label="Tên tài khoản"
					rules={[
						{
							required: true,
							message: 'Vui lòng nhập tên tài khoản',
						}
					]}>
					<Input prefix={<MailOutlined className="text-primary" />} />
				</Form.Item>
				<Form.Item
					name="PassWord"
					label={
						<div>
							<span>Mật khẩu</span>
						</div>
					}
					rules={[
						{
							required: true,
							message: 'Vui lòng nhập mật khẩu',
						}
					]}
				>
					<Input.Password prefix={<LockOutlined className="text-primary" />} />
				</Form.Item>
				<Form.Item>
					<Button type="primary" htmlType="submit" block loading={loadingLogin}>
						Sign In
					</Button>
				</Form.Item>
			</Form>
		</>
	)
}

export default LoginForm
